import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsApiService {
     private readonly BASE_URL: string;

    constructor(
        private http: HttpClient
    ) {
        this.BASE_URL = `${environment.serverURL}/google-maps`;
    }

    geocodingRequest(lat: number, lng: number): Observable<any> {
        const body = { lat, lng };
        const url = `${this.BASE_URL}/reverse-geocoding`;

        return this.http.post(url, body);
    }

    staticMapRequest(center: string, zoom: number): Observable<any> {
        const url = `${this.BASE_URL}/static-map`;
        const options = { params: { center, zoom } };
        return this.http.get(url, options);
    }
}
